import { Data } from '@shared/api/types';
import { DataTable } from '@shared/ui/components/DataTable';

type WristbandData = App.Domain.Wristband.Data.WristbandData;

type Columns = 'period' | 'day' | 'barcode' | 'printedAt' | 'printedBy' | 'status' | 'actions';

type WristbandsDataTableProps = {
  wristbands: Data<WristbandData>;
  columns?: Partial<{ [k in Columns]: boolean }>;
  avoidPagination?: boolean;
  withoutFilters?: boolean;
};

export function WristbandsDataTable({
  wristbands,
  columns = {},
  avoidPagination = false,
  withoutFilters = false,
}: WristbandsDataTableProps) {
  return (
    <DataTable<WristbandData>
      data={wristbands}
      columns={[
        {
          visible: columns.period !== false,
          name: 'period',
          sortable: false,
          render: (row) => row.accessVoucher?.accessVoucherTemplate?.period?.name,
        },
        {
          visible: columns.day !== false,
          name: 'day',
          sortable: false,
          render: (row) =>
            row.accessVoucher?.accessVoucherTemplate?.day ? row.accessVoucher?.accessVoucherTemplate?.day : 'Combi',
        },
        {
          visible: columns.barcode !== false,
          name: 'barcode',
          sortable: false,
          render: (row) => row.code,
        },
        {
          visible: columns.printedAt !== false,
          name: 'printed_at',
          sortable: false,
          type: 'datetime',
        },
        {
          visible: columns.printedBy !== false,
          name: 'printed_by',
          sortable: false,
          render: (row) => row.printedByUser?.name,
        },
        {
          visible: columns.status !== false,
          name: 'status',
          sortable: false,
          render: (row) => (
            <span className={'m-badge m-badge--' + (row.invalidatedAt ? 'danger' : 'success') + ' m-badge--wide'}>
              {row.invalidatedAt ? 'Invalidated' : 'Active'}
            </span>
          ),
        },
        {
          visible: columns.actions !== false,
          render: (row) => null, // @todo Buttons
          type: 'actions',
        },
      ]}
      avoidPagination={avoidPagination}
      withoutFilters={withoutFilters}
    />
  );
}
